import { HorseBreeder } from "./horseBreeder";
import { HorseNomination } from "./horseNomination";
import { HorseOwner } from "./horseOwner";

export class Horse {
    id: number;
    name: string;

    aqhaId: string;
    breedRegistrationId: string;
    cogginsFileName: string;
    cogginsExpirationDate: string;
    cogginsExpired: boolean;
    
    sex: string;
    birthDate: string;

    registrationPaperFileName: string;

    sire: Horse;
    sireId: number;
    dam: Horse;
    damId: number;

    owner: HorseOwner;
    ownerId: number;
    breeder: HorseBreeder;
    breederId: number;

    isNominated: boolean;
    nominations: HorseNomination[];
}


// WEBPACK FOOTER //
// ./src/model/horse.ts